module.exports = __webpack_public_path__ + "static/media/carat.db4b306d.svg";